import { render, staticRenderFns } from "./BusinessDirectoryCategoriesManager.vue?vue&type=template&id=9afd935e&"
import script from "./BusinessDirectoryCategoriesManager.vue?vue&type=script&lang=js&"
export * from "./BusinessDirectoryCategoriesManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports